import React, { Component } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import {
  Col,
  Container,
  Jumbotron,
  Nav,
  NavItem,
  Row } from 'reactstrap';

import Banners from './Banners';
import FAQs from './FAQs';
import Guides from './Guides';
import Videos from './Videos';

const IconVideos = () => (
  <svg width="25px" height="20px" viewBox="0 0 25 20">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-366.000000, -260.000000)" fill="#FFFFFF" fillRule="nonzero">
              <g transform="translate(0.000000, 242.000000)">
                  <path d="M389.828125,18.5 L389.4375,18.5 L389.4375,19.4765625 C389.4375,19.7988281 389.173828,20.0625 388.851562,20.0625 L386.898438,20.0625 C386.576172,20.0625 386.3125,19.7988281 386.3125,19.4765625 L386.3125,18.5 L370.6875,18.5 L370.6875,19.4765625 C370.6875,19.7988281 370.423828,20.0625 370.101562,20.0625 L368.148438,20.0625 C367.826172,20.0625 367.5625,19.7988281 367.5625,19.4765625 L367.5625,18.5 L367.171875,18.5 C366.522461,18.5 366,19.0224609 366,19.671875 L366,36.078125 C366,36.7275391 366.522461,37.25 367.171875,37.25 L367.5625,37.25 L367.5625,36.2734375 C367.5625,35.9511719 367.826172,35.6875 368.148438,35.6875 L370.101562,35.6875 C370.423828,35.6875 370.6875,35.9511719 370.6875,36.2734375 L370.6875,37.25 L386.3125,37.25 L386.3125,36.2734375 C386.3125,35.9511719 386.576172,35.6875 386.898438,35.6875 L388.851562,35.6875 C389.173828,35.6875 389.4375,35.9511719 389.4375,36.2734375 L389.4375,37.25 L389.828125,37.25 C390.477539,37.25 391,36.7275391 391,36.078125 L391,19.671875 C391,19.0224609 390.477539,18.5 389.828125,18.5 Z M370.6875,33.5390625 C370.6875,33.8613281 370.423828,34.125 370.101562,34.125 L368.148438,34.125 C367.826172,34.125 367.5625,33.8613281 367.5625,33.5390625 L367.5625,31.5859375 C367.5625,31.2636719 367.826172,31 368.148438,31 L370.101562,31 C370.423828,31 370.6875,31.2636719 370.6875,31.5859375 L370.6875,33.5390625 Z M370.6875,28.8515625 C370.6875,29.1738281 370.423828,29.4375 370.101562,29.4375 L368.148438,29.4375 C367.826172,29.4375 367.5625,29.1738281 367.5625,28.8515625 L367.5625,26.8984375 C367.5625,26.5761719 367.826172,26.3125 368.148438,26.3125 L370.101562,26.3125 C370.423828,26.3125 370.6875,26.5761719 370.6875,26.8984375 L370.6875,28.8515625 Z M370.6875,24.1640625 C370.6875,24.4863281 370.423828,24.75 370.101562,24.75 L368.148438,24.75 C367.826172,24.75 367.5625,24.4863281 367.5625,24.1640625 L367.5625,22.2109375 C367.5625,21.8886719 367.826172,21.625 368.148438,21.625 L370.101562,21.625 C370.423828,21.625 370.6875,21.8886719 370.6875,22.2109375 L370.6875,24.1640625 Z M389.4375,33.5390625 C389.4375,33.8613281 389.173828,34.125 388.851562,34.125 L386.898438,34.125 C386.576172,34.125 386.3125,33.8613281 386.3125,33.5390625 L386.3125,31.5859375 C386.3125,31.2636719 386.576172,31 386.898438,31 L388.851562,31 C389.173828,31 389.4375,31.2636719 389.4375,31.5859375 L389.4375,33.5390625 Z M389.4375,28.8515625 C389.4375,29.1738281 389.173828,29.4375 388.851562,29.4375 L386.898438,29.4375 C386.576172,29.4375 386.3125,29.1738281 386.3125,28.8515625 L386.3125,26.8984375 C386.3125,26.5761719 386.576172,26.3125 386.898438,26.3125 L388.851562,26.3125 C389.173828,26.3125 389.4375,26.5761719 389.4375,26.8984375 L389.4375,28.8515625 Z M389.4375,24.1640625 C389.4375,24.4863281 389.173828,24.75 388.851562,24.75 L386.898438,24.75 C386.576172,24.75 386.3125,24.4863281 386.3125,24.1640625 L386.3125,22.2109375 C386.3125,21.8886719 386.576172,21.625 386.898438,21.625 L388.851562,21.625 C389.173828,21.625 389.4375,21.8886719 389.4375,22.2109375 L389.4375,24.1640625 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>
);

const IconBanners = () => (
  <svg width="23px" height="20px" viewBox="0 0 23 20">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-516.000000, -260.000000)" fill="#FFFFFF" fillRule="nonzero">
              <g transform="translate(0.000000, 242.000000)">
                  <path d="M529.214286,18 L537.785714,18 C538.377455,18 538.857143,18.4796875 538.857143,19.0714286 L538.857143,26.2142857 C538.857143,26.8060268 538.377455,27.2857143 537.785714,27.2857143 L529.214286,27.2857143 C528.622545,27.2857143 528.142857,26.8060268 528.142857,26.2142857 L528.142857,19.0714286 C528.142857,18.4796875 528.622545,18 529.214286,18 Z M525.642857,18 L517.071429,18 C516.479687,18 516,18.4796875 516,19.0714286 L516,26.2142857 C516,26.8060268 516.479687,27.2857143 517.071429,27.2857143 L525.642857,27.2857143 C526.234598,27.2857143 526.714286,26.8060268 526.714286,26.2142857 L526.714286,19.0714286 C526.714286,18.4796875 526.234598,18 525.642857,18 Z M516,29.7857143 L516,36.9285714 C516,37.5203125 516.479687,38 517.071429,38 L525.642857,38 C526.234598,38 526.714286,37.5203125 526.714286,36.9285714 L526.714286,29.7857143 C526.714286,29.1939732 526.234598,28.7142857 525.642857,28.7142857 L517.071429,28.7142857 C516.479687,28.7142857 516,29.1939732 516,29.7857143 Z M529.214286,38 L537.785714,38 C538.377455,38 538.857143,37.5203125 538.857143,36.9285714 L538.857143,29.7857143 C538.857143,29.1939732 538.377455,28.7142857 537.785714,28.7142857 L529.214286,28.7142857 C528.622545,28.7142857 528.142857,29.1939732 528.142857,29.7857143 L528.142857,36.9285714 C528.142857,37.5203125 528.622545,38 529.214286,38 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>
);

const IconGuides = () => (
  <svg width="20px" height="24px" viewBox="0 0 20 24">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-674.000000, -258.000000)" fill="#FFFFFF" fillRule="nonzero">
              <g transform="translate(0.000000, 242.000000)">
                  <path d="M694,32.5 L694,17.6428571 C694,16.9285714 693.571429,16.5 692.857143,16.5 L678.285714,16.5 C675.857143,16.5 674,18.3571429 674,20.7857143 L674,35.0714286 C674,37.5 675.857143,39.3571429 678.285714,39.3571429 L692.857143,39.3571429 C693.428571,39.3571429 694,38.9285714 694,38.2142857 L694,37.5 C694,37.2142857 693.857143,36.9285714 693.571429,36.6428571 C693.428571,35.9285714 693.428571,33.9285714 693.571429,33.3571429 C693.857143,33.2142857 694,32.9285714 694,32.5 Z M691,36.5 L678.285714,36.5 C677.428571,36.5 676.857143,35.9285714 676.857143,35.0714286 C676.857143,34.2142857 677.571429,33.6428571 678.285714,33.6428571 L691,33.6428571 L691,36.5 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>
);

const IconFAQs = () => (
  <svg width="25px" height="25px" viewBox="0 0 25 25">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-819.000000, -257.000000)" fill="#FFFFFF" fillRule="nonzero">
              <g transform="translate(0.000000, 242.000000)">
                  <path d="M844,27.5 C844,34.4050907 838.403075,40 831.5,40 C824.596925,40 819,34.4050907 819,27.5 C819,20.5989415 824.596925,15 831.5,15 C838.403075,15 844,20.5989415 844,27.5 Z M831.835433,19.1330645 C829.088609,19.1330645 827.336694,20.2901714 825.960988,22.3466734 C825.782762,22.6131048 825.842389,22.9724294 826.097833,23.166129 L827.846774,24.4922379 C828.109123,24.6911794 828.482913,24.6438508 828.686744,24.3852823 C829.587147,23.243246 830.204536,22.580998 831.575,22.580998 C832.604687,22.580998 833.878327,23.2436996 833.878327,24.2421875 C833.878327,24.9970262 833.255192,25.3846774 832.238508,25.9546875 C831.052823,26.6193548 829.483871,27.446623 829.483871,29.516129 L829.483871,29.7177419 C829.483871,30.0517641 829.754688,30.3225806 830.08871,30.3225806 L832.91129,30.3225806 C833.245312,30.3225806 833.516129,30.0517641 833.516129,29.7177419 L833.516129,29.6505544 C833.516129,28.2159778 837.708972,28.15625 837.708972,24.2741935 C837.708972,21.3507056 834.676462,19.1330645 831.835433,19.1330645 L831.835433,19.1330645 Z M831.5,31.6330645 C830.221522,31.6330645 829.181452,32.6731351 829.181452,33.9516129 C829.181452,35.2300403 830.221522,36.2701613 831.5,36.2701613 C832.778478,36.2701613 833.818548,35.2300403 833.818548,33.9516129 C833.818548,32.6731351 832.778478,31.6330645 831.5,31.6330645 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>
);

class ResourceCenter extends Component {
  componentDidMount() {
    // Need to move page selector class up as a parent of .container-body so we can override .container-body max-width settings
    document.body.classList.add('bg-white', 'no-max');
  }
  componentWillUnmount() {
    document.body.className = '';
  }

  render() {
    const { path } = this.props.match;

    return (
      <div className="page-resource-center">

        <Container className="mb-4" fluid>

          <Jumbotron className="text-center px-0 pb-0 pt-4">
            <h1 className="pt-1">Merchant Resources</h1>
            <p className="pb-2">Tools and tips to make your business a success</p>

            <Nav className="justify-content-center mt-4">
              <NavItem>
                <NavLink to={`${path}`} className="nav-link" exact>
                  <IconVideos />
                  Videos
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={`${path}/banners`} className="nav-link">
                  <IconBanners />
                  Banners
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={`${path}/guides`} className="nav-link">
                  <IconGuides />
                  Guides
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={`${path}/faqs`} className="nav-link">
                  <IconFAQs />
                  FAQs
                </NavLink>
              </NavItem>
            </Nav>
          </Jumbotron>
        </Container>

        <Container className="pt-md-2 mb-md-4 pb-2">
          <Row>
            <Col>
              <Switch>
                <Route path={`${path}`} exact component={Videos} />
                <Route path={`${path}/banners`} component={Banners} />
                <Route path={`${path}/guides`} component={Guides} />
                <Route path={`${path}/faqs`} component={FAQs} />
              </Switch>
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
}

export default ResourceCenter;
